import Controller from "./backToTop.controller";
import template from "./backToTop.html";

const backToTop = {
  template,
  controller: Controller,
};

export default backToTop;



// WEBPACK FOOTER //
// ./src/components/backToTop/backToTop.component.js